import { CalendarDays, CalendarRange, Inbox, CheckCircle2, XCircle, Clock, AlertTriangle } from "lucide-react";
import { STATUS, eventSlot, fmtDateLong } from "./calendarUtils";

const Kpi = ({ icon: Icon, label, value, tone, testId, onClick }) => (
  <button type="button" onClick={onClick} className={`text-left bg-[#121212] border p-4 transition-colors hover:bg-white/[0.03] ${tone}`} data-testid={testId}>
    <div className="flex items-center gap-2 text-xs uppercase tracking-wider opacity-80"><Icon className="w-4 h-4" />{label}</div>
    <div className="font-['Bebas_Neue'] text-4xl mt-1">{value ?? "–"}</div>
  </button>
);

export function CalendarKpis({ stats, onView }) {
  if (!stats) return null;
  const n = stats.next_appointment;
  return (
    <div className="space-y-3 mb-6">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3">
        <Kpi icon={CalendarDays} label="Termine heute" value={stats.today} tone="border-white/10 text-white" testId="kpi-today" onClick={() => onView("day")} />
        <Kpi icon={CalendarRange} label="Diese Woche" value={stats.this_week} tone="border-white/10 text-white" testId="kpi-week" onClick={() => onView("week")} />
        <Kpi icon={Inbox} label="Offene Anfragen" value={stats.open_requests} tone="border-yellow-400/40 text-yellow-300" testId="kpi-open" onClick={() => onView("requests")} />
        <Kpi icon={CheckCircle2} label="Bestätigt (anstehend)" value={stats.confirmed} tone="border-green-500/40 text-green-400" testId="kpi-confirmed" onClick={() => onView("list")} />
        <Kpi icon={XCircle} label="Abgesagt" value={stats.cancelled} tone="border-red-500/40 text-red-400" testId="kpi-cancelled" />
      </div>
      <div className="flex flex-wrap gap-3">
        <div className="flex-1 min-w-[260px] bg-[#c1ff72]/5 border border-[#c1ff72]/30 p-4 flex items-center gap-3" data-testid="kpi-next">
          <Clock className="w-5 h-5 text-[#c1ff72]" />
          <div>
            <div className="text-xs uppercase tracking-wider text-[#c1ff72]">Nächster Termin</div>
            {n ? <div className="text-white">{fmtDateLong(eventSlot(n).date)}, {eventSlot(n).time} Uhr · {n.customer?.name} · {n.training_name}</div> : <div className="text-[#71717A]">Kein bestätigter Termin geplant</div>}
          </div>
        </div>
        {stats.alternatives_open > 0 && (
          <div className="bg-orange-500/10 border border-orange-500/40 p-4 text-orange-300 text-sm" data-testid="kpi-alternatives">{stats.alternatives_open} Alternativvorschlag{stats.alternatives_open > 1 ? "e" : ""} wartet auf Antwort</div>
        )}
        {stats.conflicts > 0 && (
          <div className="bg-red-500/10 border border-red-500/40 p-4 text-red-300 text-sm flex items-center gap-2" data-testid="kpi-conflicts"><AlertTriangle className="w-4 h-4" />{stats.conflicts} Konflikt{stats.conflicts > 1 ? "e" : ""} mit Buchungsregeln</div>
        )}
      </div>
    </div>
  );
}

export function StatusLegend() {
  return (
    <div className="flex flex-wrap gap-4 text-xs text-[#A1A1AA]" data-testid="status-legend">
      {Object.entries(STATUS).map(([k, s]) => <span key={k} className="flex items-center gap-1.5"><span className={`w-2.5 h-2.5 rounded-full ${s.dot}`} />{s.label}</span>)}
    </div>
  );
}
